import styled from "@emotion/styled"
import { IconButton } from "@mui/material"
import { CROSS_ICON } from "../../../../constants/icons/CrossIcon"
import { COLOR_MAP } from "../../../../constants/ColorNames"

type BannerProps = {
    onClose: () => void,
    bannerText: string
}
const Text = styled.p`
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 2rem;
  margin: 0;
  display: flex;
  align-items: center;
`
const Banner = styled.div`
  background-color: ${COLOR_MAP.WARNING};
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 1.2rem;
`
const FollowUpBanner = (props: BannerProps) => {
    const { bannerText, onClose } = props
    return <Banner>
        <Text>
            {bannerText}
        </Text>
        <IconButton onClick={onClose} disableRipple><CROSS_ICON /></IconButton>
    </Banner>
}
export default FollowUpBanner 